"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = getMetadata;
exports.getFileTypeInfoFromFileName = getFileTypeInfoFromFileName;
exports.getParserOpts = getParserOpts;
exports.preParseInitialization = preParseInitialization;

var _babylonLightscript = require("@oigroup/babylon-lightscript");

var babylonLightScript = _interopRequireWildcard(_babylonLightscript);

var _package = require("../package.json");

var _package2 = _interopRequireDefault(_package);

var _parseConfigurationDirectives = require("./util/parseConfigurationDirectives");

var _parseConfigurationDirectives2 = _interopRequireDefault(_parseConfigurationDirectives);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getMetadata() {
  return {
    parser: babylonLightScript,
    getParserOpts,
    parseConfigurationDirectives: _parseConfigurationDirectives2.default,
    name: _package2.default.name,
    version: _package2.default.version,
    options: {
      stdlib: {
        description: "Configure the LightScript standard library"
      },
      patternMatching: {
        description: "Test and branch using `match` keyword",
        valueType: "option",
        options: ["default", "enhanced"],
        defaultValue: "default",
        stage: "1"
      },
      enhancedTry: {
        description: "`try` expressions and pattern matching for `catch`. (HIGHLY EXPERIMENTAL. DO NOT USE IN PRODUCTION.)",
        valueType: "boolean",
        stage: "-50"
      },
      bangCall: {
        description: "Call functions with paren-free syntax using `!`",
        valueType: "boolean",
        defaultValue: true
      },
      safeCall: {
        description: "Call a function using `?` to check callability first",
        valueType: "boolean",
        defaultValue: true
      },
      existential: {
        description: "Postfix `?` checks that an expression is not loose-equal to `null`",
        valueType: "boolean"
      },
      noEnforcedSubscriptIndentation: {
        description: "Do not enforce indentation for subscripts on subsequent lines.",
        valueType: "boolean"
      },
      useRequire: {
        description: "Generate `require` rather than `import` when the compiler introduces a module.",
        valueType: "boolean"
      },
      flippedImports: {
        description: "Allow imports via `import 'path': [specifier]` syntax.",
        valueType: "boolean"
      },
      disableJsx: {
        description: "Don't parse JSX expressions.",
        valueType: "boolean"
      },
      disableFlow: {
        description: "Don't parse Flow type annotations.",
        valueType: "boolean"
      },
      placeholderArgs: {
        description: "Specify arguments for a function using placeholders in the body.",
        valueType: "boolean"
      },
      placeholder: {
        description: "Specify an identifier to be transformed into PlaceholderExpression.",
        valueType: "string"
      }
    }
  };
}function getFileTypeInfoFromFileName(filename) {
  if (!filename) return { isLightScript: true, isLSX: false };

  if (filename.includes(".lsx")) return { isLightScript: true, isLSX: true };

  if (filename === "unknown" || // eslint
  filename === "repl" || // babel-node
  filename.includes(".lsc")) return { isLightScript: true, isLSX: false };

  return { isLightScript: false, isLSX: false };
}function getFileTypeInfo(file) {
  var _file$opts;

  if (!(file == null ? void 0 : (_file$opts = file.opts) == null ? void 0 : _file$opts.filename)) return { isLightScript: true, isLSX: false };
  return getFileTypeInfoFromFileName(file.opts.filename);
}function getParserOpts(pluginOpts, initialParserOpts) {
  var parserOpts = initialParserOpts || {};
  parserOpts.parser = babylonLightScript.parse;

  parserOpts.plugins = parserOpts.plugins || [];
  var plugins = parserOpts.plugins;

  plugins.unshift("lightscript");
  plugins.push("objectRestSpread", "asyncFunctions", "asyncGenerators", "classProperties", "classConstructorCall", "decorators", "dynamicImport", "doExpressions", "seqExprRequiresParen", "noLabeledExpressionStatements", "spreadLoop", "whiteblockPreferred");

  if (!(pluginOpts == null ? void 0 : pluginOpts.disableJsx)) plugins.push("jsx");
  if (!(pluginOpts == null ? void 0 : pluginOpts.disableFlow)) plugins.push("flow");
  if ((pluginOpts == null ? void 0 : pluginOpts.safeCall) !== false) plugins.push("safeCallExpression");
  if (pluginOpts == null ? void 0 : pluginOpts.existential) plugins.push("existentialExpression");
  if ((pluginOpts == null ? void 0 : pluginOpts.bangCall) !== false) plugins.push("bangCall");
  if (!(pluginOpts == null ? void 0 : pluginOpts.noEnforcedSubscriptIndentation)) plugins.push("enforceSubscriptIndentation");
  if (pluginOpts == null ? void 0 : pluginOpts.flippedImports) plugins.push("flippedImports");
  if (pluginOpts == null ? void 0 : pluginOpts.placeholderArgs) plugins.push("syntacticPlaceholder");
  if (pluginOpts == null ? void 0 : pluginOpts.placeholder) {
    parserOpts.placeholder = pluginOpts.placeholder;
  }if (pluginOpts.enhancedTry) plugins.push("enhancedTry");

  // TODO: watch upstream on pattern matching; default to their syntax when complete
  // patternMatchingVersion = pluginOpts?.patternMatching or "v4"
  // if patternMatchingVersion != "disabled":
  //   plugins.push(`match_${patternMatchingVersion}`)
  plugins.push("match");

  return parserOpts;
} // Pre-parse initialization of compiler state. All configuration data is
// collected here.
function preParseInitialization(compiler, babelFile, pluginOpts) {
  compiler.file = babelFile;
  compiler.opts = pluginOpts;

  babelFile.parseShebang();
  var opts = babelFile.opts,
      parserOpts = babelFile.parserOpts,
      code = babelFile.code;

  var fileTypeInfo = getFileTypeInfo(babelFile);
  if (fileTypeInfo.isLightScript && pluginOpts.isLightScript === undefined) {
    pluginOpts.isLightScript = true;
  }var directiveOpts = (0, _parseConfigurationDirectives2.default)(code);
  Object.assign(pluginOpts, directiveOpts);

  if (pluginOpts.isLightScript) {
    compiler.isLightScript = true;
    babelFile.isLightScript = true;
    compiler.isLSX = pluginOpts.isLSX;
    babelFile.isLSX = pluginOpts.isLSX;

    // Set up LSC parsing pipeline
    opts.parserOpts = opts.parserOpts || {};
    var nextParserOpts = getParserOpts(pluginOpts, opts.parserOpts);
    parserOpts.parse = nextParserOpts.parse;
    parserOpts.plugins = nextParserOpts.plugins;
  }
}